module.exports = __webpack_public_path__ + "img/neoco-logo-white.838019f9.svg";